<div class="container">
  <img class="anota-ai-logo" src="../../../assets/logo-text.svg" />
  <img class="not-found" src="../../../assets/not-found.svg" />
  <h1>Ocorreu um Erro!</h1>
  <p>
    Algo deu errado ao processar suas informações.
    <br />
    Por favor, preencha novamente as informações do seu cadastro.
  </p>
  <anota-button (click)="continue()">Reiniciar Cadastro</anota-button>
</div>
